var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbAlertErrorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.892,
    height: 12,
    viewBox: "0 0 12.892 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle-svgrepo-com",
    transform: "translate(-2.395 -3.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M8.17,9.75a.671.671,0,1,0,1.342,0V7.737a.671.671,0,1,0-1.342,0Zm1.342,2.006a.671.671,0,1,0-1.342,0v.008a.671.671,0,0,0,1.342,0Zm-2.431-7.6a2.013,2.013,0,0,1,3.52,0l4.43,7.974a2.013,2.013,0,0,1-1.76,2.991H4.411a2.013,2.013,0,0,1-1.76-2.991Z",
    transform: "translate(0)",
    fill: "#e00f0f",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbAlertErrorIcon);
export default __webpack_public_path__ + "static/media/fb-alert-error-icon.b82284bda259ba8abbd26ce491e0c4eb.svg";
export { ForwardRef as ReactComponent };